var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { snackbarService } from "../services/snackbarService";
import { handleError } from "./error";
export const createRequest = (request, { onSuccess, onError, successMessage, defaultErrorMessage = "Произошла неизвестная ошибка", } = {}) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield request;
        onSuccess && (yield onSuccess(response));
        if (successMessage)
            snackbarService.show({
                variant: "success",
                message: successMessage,
            });
        return response;
    }
    catch (error) {
        onError && (yield onError(error));
        handleError({
            error,
            defaultError: defaultErrorMessage,
        });
        // @ts-ignore
        return error;
    }
});
export default {
    createRequest,
};
//# sourceMappingURL=request.js.map